import { render, staticRenderFns } from "./DetailComponent.vue?vue&type=template&id=059c9d0e&"
import script from "./DetailComponent.vue?vue&type=script&lang=js&"
export * from "./DetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059c9d0e')) {
      api.createRecord('059c9d0e', component.options)
    } else {
      api.reload('059c9d0e', component.options)
    }
    module.hot.accept("./DetailComponent.vue?vue&type=template&id=059c9d0e&", function () {
      api.rerender('059c9d0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/detail-component/DetailComponent.vue"
export default component.exports